import { loadEsri, Geoprocessor } from './esriLoadService'
import loggingService from './util/loggingService'
const appConfig = require('../../static/config/config.json')

var isDebug = false
var gp
var zipSet = false

const gisGPServiceUrls = {}
gisGPServiceUrls.zipGPService = appConfig.gis_url + appConfig.Map_FileSearchZipServiceEndpoint

function getZipServiceUrl (token) {
    return new Promise((resolve, reject) => {
        loadEsri('gisZipService.getZipServiceUrl').then(() => {
            if (!zipSet) {
                gisGPServiceUrls.zipGPService = gisGPServiceUrls.zipGPService + '?token=' + token
                resolve(gisGPServiceUrls.zipGPService)
                zipSet = true
            } else {
                resolve(gisGPServiceUrls.zipGPService)
            }
        })
    })
}

function log (message, object) {
    loggingService.log(isDebug, 'gisService', message)
    if (object) {
        loggingService.logRaw(isDebug, object)
    }
}

function gpSiteZip (results, token) {
    return new Promise((resolve, reject) => {
        getZipServiceUrl(token).then(zipServiceUrl => {
            zipServiceUrl += '&f=json'
            gp = new Geoprocessor(zipServiceUrl)
            var params = {
                input_json_string: results
            }
            log(params)
            gp.submitJob(params, gpJobComplete, gpJobStatus, gpJobFailed).then(response => {
                resolve(response)
            })
        })
    })
}

function gpJobStatus (jobinfo) {
    var jobstatus = ''
    switch (jobinfo.jobStatus) {
    case 'esriJobSubmitted':
        jobstatus = 'Submitted...'
        break
    case 'esriJobExecuting':
        jobstatus = 'Executing...'
        break
    case 'esriJobSucceeded':
        jobstatus = 'Succedded...'
        break
    }

    console.log(jobstatus)
}

function gpJobComplete (jobinfo) {
    //get the Zipfile back from the service
    gp.getResultData(jobinfo.jobId, 'output_shapefile_zip', zipDownload)
}

function gpJobFailed (error) {
    log(error)
}

function zipDownload (zipResult) {
    var link = document.createElement('a')
    link.href = zipResult.value.url
    link.download = 'Download Zip'
    document.body.appendChild(link)
    link.click()
}

export default {
    gpSiteZip: gpSiteZip
}



// WEBPACK FOOTER //
// ./src/services/gisZipService.js